import { create } from 'zustand'
import { persist } from 'zustand/middleware'
import { LoginUser, RefreshSession } from '../utils/auth.utils'
import { isArray } from 'util'
import { Session_Auth, User_Auth } from '../types/auth.types'

// 1. Define types for your data structures
// interface User {
//   id: string
//   name: string
//   email: string
// }

interface LoginCredentials {
  email: string
  password: [string, string] | string // Adjust based on your API schema
}

// 2. Separate State and Actions into TypeScript interfaces
interface AuthState {
  user: User_Auth | null
  session: Session_Auth | null
  // token: string | null
  isLoading: boolean
  error: string | null
}

interface AuthActions {
  login: (credentials: LoginCredentials) => Promise<void>;
  checkSession: () => Promise<void>;
  logout: () => void;
  clearError: () => void;
}

// Combine both interfaces for the complete Store type
type AuthStore = AuthState & AuthActions

// 3. Create the type-safe store using the combined interface
const useAuthStore = create<AuthStore>()(
  persist(
    (set, get) => ({
      // State initial values
      user: null,
      session: null,
      isLoading: false,
      error: null,

      // Actions
      login: async (credentials) => {
        set({ isLoading: true, error: null })
        try {
          const email = credentials.email ?? '';
          let password = credentials.password ?? '';
          if (Array.isArray(password)) password = credentials.password[0]

          debugger
          const { data, error } = await LoginUser({ email, password })
          alert('Logging in!')

          const session: Session_Auth = {
            access_token: data.session?.access_token ?? '',
            token_type: data.session?.token_type ?? '',
            expires_in: data.session?.expires_in ?? 0,
            expires_at: data.session?.expires_at ?? 0,
            refresh_token: data.session?.refresh_token ?? ''
          };

          const last_sign_in_at = data.user?.last_sign_in_at ? new Date(data.user.last_sign_in_at) : undefined;
          debugger;
          let user: User_Auth = {
            id: data.user?.id ?? '',
            aud: data.user?.aud ?? '',
            // DisplayName: data.user?.DisplayName ?? '',
            role: data.user?.role ?? '',
            email: data.user?.email ?? '',
            phone: data.user?.phone ?? '',
            last_sign_in_at: last_sign_in_at
          };


          set({ user: user, session: session, isLoading: false })

        } catch (err) {
          const message = err instanceof Error ? err.message : 'An error occurred'
          set({ error: message, isLoading: false })
        }
      },
      checkSession: async () => {
        const session = get().session;
        if (!session) {
          get().logout();
          console.log('Session Invalid. Logging out...');
          alert('Session Invalid. Logging out...');
          return
        };


        // 1. Define a safety buffer (e.g., 60 seconds in milliseconds)
        const BUFFER_MS = 60 * 1000;

        // 2. Parse expiration time to milliseconds
        const expiresAtMs = typeof session.expires_at === 'number'
          ? session.expires_at * 1000
          : new Date(session.expires_at).getTime();

        // 3. Determine the refresh threshold
        const refreshThresholdMs = expiresAtMs - BUFFER_MS;

        // 4. Compare against the current device time
        const shouldRefresh = Date.now() >= refreshThresholdMs;

        if (shouldRefresh ) {
          console.log("Token is nearing expiration or expired. Refreshing token...");
          // Call your Supabase refresh token logic here:
          // await supabase.auth.refreshSession();
          const { data, error } = await RefreshSession(session.refresh_token)
          if (error) {
            alert('Error refreshing session: ' + error.message);
            get().logout();
            return
          }

          const newSession: Session_Auth = {
            access_token: data.session?.access_token ?? '',
            token_type: data.session?.token_type ?? '',
            expires_in: data.session?.expires_in ?? 0,
            expires_at: data.session?.expires_at ?? 0,
            refresh_token: data.session?.refresh_token ?? ''
          };

          const last_sign_in_at = data.user?.last_sign_in_at ? new Date(data.user.last_sign_in_at) : undefined;

          let user: User_Auth = {
            id: data.user?.id ?? '',
            aud: data.user?.aud ?? '',
            role: data.user?.role ?? '',
            email: data.user?.email ?? '',
            phone: data.user?.phone ?? '',
            last_sign_in_at: last_sign_in_at
          };
          alert('Session successfully refreshed!')
          set({ user: user, session: newSession, isLoading: false })
        } else {
          console.log("Token is still valid. No refresh needed.");
        }
      },

      logout: () => {
        alert('Logging out!')
        set({ user: null, session: null, error: null })
      },

      clearError: () => set({ error: null }),
    }),
    {
      name: 'auth-storage',
      // Explicitly pick which typed states to persist
      partialize: (state) => ({ user: state.user, session: state.session }),
    }
  )
)

export default useAuthStore
